import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'admin-app',
    template: '<router-outlet></router-outlet>',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterOutlet]
})
export class AppComponent {
  private readonly iconReg = inject(MatIconRegistry);

  constructor() {
    this.iconReg.setDefaultFontSetClass('material-symbols-outlined');
  }
}
